import React, { Fragment, useEffect, useState } from 'react';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import styled from 'styled-components/macro';

import { MerchantNavigation } from '../../navigation/MerchantNavigation';
import { useRouteMatch } from 'react-router-dom';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { Button, Card, Grid } from '@material-ui/core';
import { Camera } from 'react-feather';
import { CommonLogic } from '@jewelutions/core-common-logic';

interface IProps {
  party: GQLParty;
}

const StyledDesignerAppDiv = styled.div`
  width: 80vw;
  @media (max-width: 820px) {
    width: 97vw;
  }
`;

const MerchantChannelCatalogPreview: React.FC<IProps> = ({ party }: IProps) => {
  const [commonView, setCommonView] = useState(null);

  const { merchantChannelCatalogId } = MerchantNavigation.merchantChannelCatalogDetails.paramsFromPath(
    useRouteMatch()
  );

  const {
    data,
    loading
  } = GQLOperationBuilder.merchantChannelCatalog.getDesignerCatalogFromMerchantChannelCatalog({
    merchantChannelCatalogId: merchantChannelCatalogId
  });

  useEffect(() => {
    async function initialiseDesigner() {
      const catalog = JSON.parse(
        CommonLogic.Base64.fromBase64(
          GQLOperationBuilder.merchantChannelCatalog.designerCatalogFromResponse(data)
        )
      );

      const commonViewApi = await (globalThis as any).Jewelutions.developmentLoad(
        (globalThis as any).Jewelutions.configurationBuilder()
          .withAppRootDomElementId('designer_app')
          .withCatalog(catalog)
          .build()
      );
      setCommonView(commonViewApi);
    }
    if (data) {
      initialiseDesigner();
    }
  }, [data]);

  const downloadScreenshot = async () => {
    const view = commonView as any;
    const base64Image = await view.exportCanvasImage();

    const element = document.createElement('a');
    if (base64Image) {
      element.href = base64Image;
      element.download = `image.png`;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
    }
  };

  return (
    <Fragment>
      <Grid container direction="row">
        <Grid item md={4} style={{ marginBottom: '8px' }}>
          <Button
            variant="contained"
            color="primary"
            style={{ marginBottom: '8px' }}
            onClick={() => {
              downloadScreenshot();
            }}
          >
            <Camera />
            <span style={{ marginLeft: '4px' }}>Download screenshot</span>
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={6}>
        <StyledDesignerAppDiv id="designer_app" />
      </Grid>
    </Fragment>
  );
};
export default MerchantChannelCatalogPreview;
